import { IPerformanceTeamOverviewQuery } from '../interfaces/performance-team-overview.query.interface';

// @dynamic
export class PerformanceTeamOverview {
    inProgressTeamReviews: number;
    overdueTeamReviews: number;
    totalNumber: number;

    constructor(query: IPerformanceTeamOverviewQuery) {
        this.inProgressTeamReviews = query.in_progress_team_reviews;
        this.overdueTeamReviews = query.overdue_team_reviews;
        this.totalNumber = query.total_number;
    }
}
